export default class InformationBarUtils {

  static collapsedBar: boolean;
  static encounterSectorCode: number;
  static age: number;
  static allowInfo: boolean;

  static clean(): void {
    this.encounterSectorCode = 0;
    this.age                 = 0;
  }

}
